import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { ProvidersDeleteDialog } from 'pages/Providers/components/ProvidersDeleteDialog/ProvidersDeleteDialog';
import { CancelButton, DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { UserActionsIconButton } from 'shared/mui/IconButtons/UserActionsIconButton/UserActionsIconButton';
import { ProviderShowTable } from 'shared/widgets/ProviderShowTable/ProviderShowTable';
import { Permission } from 'types/embedded/permission';
import { Provider } from 'types/embedded/provider';

type Props = {
  record?: Provider;
};

export const ProvidersShowCommonInfo: React.FC<Props> = ({ record }) => {
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<Provider>();

  return (
    <Card sx={{ border: '1px solid', borderColor: 'divider' }}>
      <CardHeader
        appendActions={
          hasResourceAccess(Resources.UserActions)
            ? [<UserActionsIconButton entityName="provider" key="user-action-link" />]
            : undefined
        }
        title="Общая информация"
        titleSize="smallBold"
      />
      <CardContent>
        <ProviderShowTable />
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          hasResourcePermissions(Resources.Providers, [Permission.Full, Permission.Delete]) && (
            <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
          ),
          hasResourcePermissions(Resources.Providers, [Permission.Full, Permission.Update]) && (
            <EditLinkButton variant="contained" />
          ),
        ]}
      />
      {openRecordModalDelete && (
        <ProvidersDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={record}
        >
          <CancelButton
            key="history-back-button"
            label="Вернуться к списку провайдеров"
            linkType="exit"
            variant="outlined"
          />
        </ProvidersDeleteDialog>
      )}
    </Card>
  );
};
